<template>
  <div>
    <div class=" text-[#505050] p-2 text-center font-bold text-3xl font-sans border-b-8 border-gray-800">
      {{ title }}
    </div>
  </div>
</template>
<script>
export default {
  props: ["title"],
};
</script>